import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-menu\">\n  <path fill=\"currentColor\" d=\"M4 4.9h12v1.8H4V4.9zM4 9.1h12v1.8H4V9.1zM4 13.3h7.2v1.8H4v-1.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol